import DOMPurify from 'dompurify';

/**
 * Create a button element.
 *
 * @param {String} className class to be added to button.
 * @param {String} text text/HTML to be added to button.
 * @param {Array} attributes array of attribute name/value object to be added to button.
 * @param callback 'onClick' callback to be attached to button.
 * @returns {HTMLButtonElement}
 */
const createButton = (className, text, attributes = [], callback) => {
  const button = document.createElement('button');
  if (className) {
    button.classList.add(className);
  }

  if (text) {
    button.innerHTML = DOMPurify.sanitize(text, { ALLOWED_TAGS: ['span'] });
  }

  if (attributes && Array.isArray(attributes)) {
    Array.prototype.forEach.call(attributes, (attributeObject) => {
      if (! attributeObject.name && attributeObject.value) {
        return;
      }

      button.setAttribute(attributeObject.name, attributeObject.value);
    });
  }

  if (callback) {
    button.addEventListener('click', callback);
  }

  return button;
};

export default createButton;
